import { Modal, Button, DatePicker, message } from 'antd';
import React, { Component } from 'react';
import moment from 'moment';
import downloadBtn from '@/assets/download-btn.jpg';
import locale from 'antd/es/date-picker/locale/zh_CN';
import style from './index.less';
import 'moment/locale/zh-cn';
import { exportData } from '@/services/request';
import { fileDownload } from '@/shared/loadExecl';
moment.locale('zh-cn');
const { RangePicker } = DatePicker;
export default class DownloadDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dates: [],
            dateStrs: [],
            showDialog: false,
        };
    }
    componentDidMount() {
        this.initDialog();
    }
    initDialog() {
        const now = new Date().getTime();
        const dates = [
            moment(now),
            moment(now),
        ];
        const dateStrs = [
            moment(now).format('YYYY-MM-DD'),
            moment(now).format('YYYY-MM-DD'),
        ];
        this.setState({
            dates,
            dateStrs,
        });
    }
    toggleDownloadDialog(val) {
        this.setState({
            showDialog: val,
        });
    }
    handleDownload() {
        const { dateStrs } = this.state;
        const params = {
            productCode: this.props.sceneCode || '',
            type: this.props.type,
            dateStr: dateStrs,
        };
        exportData(params).then((data) => {
            const fileName = data.headers['content-disposition'].match(/filename=(.*)$/)[1];
            fileDownload(data.data, fileName);
            this.toggleDownloadDialog(false);
        }).catch((error) => {
            console.log(error);
            message.error(error.msg || '下载失败');
        });
    }
    changeDateRange(dates) {
        const dateStrs = [
            moment(dates[0]).format('YYYY-MM-DD'),
            moment(dates[1]).format('YYYY-MM-DD'),
        ];
        this.setState({
            dates,
            dateStrs,
        });
    }
    disabledDate(current) {
        return current && current > moment().endOf('day');
    }
    reset() {
        this.initDialog();
    }
    render() {
        const { dates, showDialog } = this.state;
        const { className } = this.props;
        return (<>
        <img src={downloadBtn} alt="" className={className} onClick={this.toggleDownloadDialog.bind(this, true)}/>
        <Modal title="数据下载" className="data-download-dialog" visible={showDialog} width={480} footer={false} maskClosable={false} onCancel={this.toggleDownloadDialog.bind(this, false)}>
          <div className="date-range-content" style={style}>
            <span>下载日期范围&nbsp;&nbsp;</span>
            <RangePicker locale={locale} value={dates} format="YYYY-MM-DD" disabledDate={this.disabledDate} onChange={(dates) => {
            this.changeDateRange(dates);
        }}/>
            <div className="btns">
              <Button onClick={this.reset.bind(this)} className="mr_20">重置</Button>
              <Button type="primary" onClick={this.handleDownload.bind(this)}>确定</Button>
            </div>
          </div>
        </Modal>
      </>);
    }
}
;
